import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseMeshyRetextureProData. Builds an openedModel-shaped payload
 * from the current textureSettings (plus the modelSettings 3D output) so the
 * just-submitted run can be reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseMeshyRetextureProData
 */
export const buildMeshyRetextureProFromState = (state, id) => {
  const {
    prompt,
    enablePbr,
    inputImage,
    inputImageUrl,
    textureQuality,
  } = state.textureSettings || {}
  const { isPrivate } = state.modelSettings || {}
  const materialMode = deriveMaterial(enablePbr, false)
  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER.MESHY,
    providerModelId: MODEL_ID.MESHY_RETEXTURE_PRO,
    prompt,
    enablePbr,
    private: isPrivate,
    inputAssets,
    providerRunAttributes: {
      ...(materialMode != null && { materialMode }),
      ...(textureQuality != null && { textureQuality }),
    },
  }
}
